import { c as _c } from "react/compiler-runtime";
import { ApiClient } from '@/services/api-client';
import { useQuery } from '@tanstack/react-query';
export function usePendingReviewsCount() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["conversationReviews.pendingCount"],
      queryFn: _temp,
      staleTime: 60000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const q = useQuery(t0);
  return q.data?.PendingCount ?? 0;
}
function _temp() {
  return ApiClient.conversationReviews.listReviews("PENDING", 1);
}